/**
 * 帳單領取方式
 */
export const billReceiveMethod = [
  { value: 0, text: '郵寄' },
  { value: 1, text: '通知業務' },
  { value: 2, text: '自取' },
  { value: 3, text: '萬事達-郵寄' },
  { value: 4, text: '萬事達-自取' },
  { value: 5, text: '萬事達-特殊' },
  { value: 6, text: '自動扣款' },
  { value: 7, text: '墊繳' },
  { value: 8, text: '特殊' },
  { value: 9, text: '不印帳單' },
  { value: 10, text: '萬事達-不印帳單' },
];

/**
 * 帳單類型
 */
export const billType = [
  { value: 'M', text: '互助費' },
  { value: 'Y', text: '平台年費' },
  { value: 'F', text: '上期手續費' },
  { value: 'S', text: '回饋金' },
  { value: 'B', text: '墊繳手續費' }
];

/**
 * 總後台側邊菜單資料
 */
export const sideMemuData = [
  {
      'title': '契約管理', url: '#', icon: 'fas fa-solid fa-file-signature', isShow:false, meta: { permission: [], permission_tag: ['contract_management'], permission_type: ['search'] }, children: [
          { name: '契約', url: '/backstage/yf/contract', meta: { permission: [], permission_tag: ['contract'], permission_type: ['search', 'update'] }},
          { name: '契約促銷設定', url: '/backstage/yf/contractPromotionSetting', meta: { permission: [], permission_tag: ['contract_promotion_setting'], permission_type: ['search', 'update'] }},
          { name: '通知書', url: '/backstage/yf/contractNotice', meta: { permission: [], permission_tag: ['notice'], permission_type: ['search'] }},
      ]
  },
  {
      'title': '業務管理', url: '#', icon: 'fas fa-solid fa-business-time', isShow:false, meta: { permission: [], permission_tag: ['business_management'], permission_type: ['search'] }, children: [
          { name: '業務', url: '/backstage/yf/business', meta: { permission: [], permission_tag: ['business'], permission_type: ['search', 'update'] }},
          { name: '業務組織樹', url: '/backstage/yf/businessOrganizationTree', meta: { permission: [], permission_tag: ['business_organization_tree'], permission_type: ['search'] }},
          { name: '每期業務權益2.0總表', url: '/backstage/yf/businessEquityV2', meta: { permission: [], permission_tag: ['business_equity_V2'], permission_type: ['search'] }},
      ]
  },
  {
      'title': '帳單管理', url: '#', icon: 'fab fa-brands fa-cc-mastercard', isShow:false, meta: { permission: [], permission_tag: ['bill_management'], permission_type: ['search'] }, children: [
          { name: '未繳帳單', url: '/backstage/yf/unpaidBills', meta: { permission: [], permission_tag: ['unpaid_bills'], permission_type: ['search', 'update'] }},
          { name: '繳費細項', url: '/backstage/yf/payDetails', meta: { permission: [], permission_tag: ['pay_details'], permission_type: ['search'] }},
          { name: '帳單設定', url: '/backstage/yf/billingSettings', meta: { permission: [], permission_tag: ['billing_settings'], permission_type: ['search', 'update'] }},
      ]
  },
  {
      'title': '理賠', url: '#', icon: 'fas fa-solid fa-money-bill', isShow:false, meta: { permission: [], permission_tag: ['claims'], permission_type: ['search'] }, children: [
          { name: '未處理互助金', url: '/backstage/yf/unProcessedMutualAidMoney', meta: { permission: [], permission_tag: ['unprocessed_mutual_aid_money'], permission_type: ['search', 'update'] }},
          { name: '已理賠互助金', url: '/backstage/yf/claimedAidFund', meta: { permission: [], permission_tag: ['claimed_aid_fund'], permission_type: ['search', 'update'] }},
          { name: '身故請領表', url: '/backstage/yf/deceasedClaimForm', meta: { permission: [], permission_tag: ['deceased_claim_form'], permission_type: ['search'] }},
          { name: '匯出理賠', url: '/backstage/yf/exportClaim', meta: { permission: [], permission_tag: ['export_claim'], permission_type: ['search'] }},
      ]
  },
  {
      'title': '報表', url: '#', icon: 'fa fa-bar-chart', isShow:false, meta: { permission: [], permission_tag: ['report'], permission_type: ['search'] }, children: [
          { name: '查詢已繳費', url: '/backstage/yf/paidReport', meta: { permission: [], permission_tag: ['paid_report'], permission_type: ['search'] }},
          { name: '每月新增人數', url: '/backstage/yf/monthlyNewUserReport', meta: { permission: [], permission_tag: ['monthly_new_user_report'], permission_type: ['search'] }},
          { name: '每月身故理賠人數', url: '/backstage/yf/monthlyDeceasedClaimsReport', meta: { permission: [], permission_tag: ['monthly_deceased_user_report'], permission_type: ['search'] }},
          { name: '身故會員理賠分布', url: '/backstage/yf/deathMemberClaim', meta: { permission: [], permission_tag: ['death_member_claim'], permission_type: ['search'] }},
          { name: '每月繳滿人數', url: '/backstage/yf/monthlyFullPaymentCount', meta: { permission: [], permission_tag: ['monthly_full_payment_count'], permission_type: ['search'] }},
          { name: '地區相關數據', url: '/backstage/yf/regionalDataReport', meta: { permission: [], permission_tag: ['regional_data_report'], permission_type: ['search'] }},
          { name: '帳單相關數據', url: '/backstage/yf/billDataReport', meta: { permission: [], permission_tag: ['bill_data_report'], permission_type: ['search'] }},
          { name: '每月件數', url: '/backstage/yf/monthlyCount', meta: { permission: [], permission_tag: ['monthly_count_report'], permission_type: ['search'] }},
          { name: '互助人年齡層分布', url: '/backstage/yf/memberAgeDistribution', meta: { permission: [], permission_tag: ['member_age_distribution_report'], permission_type: ['search'] }},
          { name: '業務年齡層分布', url: '/backstage/yf/salesAgeDistribution', meta: { permission: [], permission_tag: ['sales_age_distribution_report' ], permission_type: ['search'] }},
          { name: '失效會員繳款次數', url: '/backstage/yf/memberExclusionPaycount', meta: { permission: [], permission_tag: ['member_exclusion_paycount'], permission_type: ['search'] }},
          { name: '匯出報表', url: '/backstage/yf/exportReport', meta: { permission: [], permission_tag: ['export_report'], permission_type: ['search'] }},
      ]
  },
  {
      'title': '設定', url: '#', icon: 'fa fa-solid fa-gear', isShow:false, meta: { permission: [], permission_tag: ['set'], permission_type: ['search'] }, children: [
          { name: '環境設定', url: '/backstage/yf/config', meta: { permission: [], permission_tag: ['config'], permission_type: ['search', 'update'] }},
          { name: '安全中心', url: '/backstage/yf/securityCenter', meta: { permission: [], permission_tag: ['security_center'], permission_type: ['search', 'update'] }},
          { name: '前台數據設定', url: '/backstage/yf/frontendDataSetup', meta: { permission: [], permission_tag: ['frontend_data_setup'], permission_type: ['search', 'update'] }},
          { name: '權限設定', url: '/backstage/yf/permissionSettings', meta: { permission: [], permission_tag: ['permission_settings'], permission_type: ['search', 'update'] }},
      ]
  },
  {
      'title': '操作日誌', url: '#', icon: 'fa fa-solid fa-clipboard-list', isShow:false, meta: { permission: [], permission_tag: ['log'], permission_type: ['search'] }, children: [
          { name: '契約', url: '/backstage/yf/contractLog', meta: { permission: [], permission_tag: ['contract_log'], permission_type: ['search'] }},
          { name: '業務', url: '/backstage/yf/businessLog', meta: { permission: [], permission_tag: ['business_log'], permission_type: ['search'] }},
          { name: '帳單', url: '/backstage/yf/billLog', meta: { permission: [], permission_tag: ['bill_log'], permission_type: ['search'] }},
      ]
  },
  {
      'title': '舊系統-操作日誌', url: '#', icon: 'fa fa-solid fa-clipboard-list', isShow:false, meta: { permission: [], permission_tag: ['old_system_log'], permission_type: ['search'] }, children: [
          { name: '契約', url: '/backstage/yf/oldSystemContractLog', meta: { permission: [], permission_tag: ['old_system_contract_log'], permission_type: ['search'] }},
          { name: '契約繳費通知地址', url: '/backstage/yf/oldSystemContractPayNoticeAddressLog', meta: { permission: [], permission_tag: ['old_system_contract_pay_notice_address_log'], permission_type: ['search'] }},
          { name: '入會費', url: '/backstage/yf/oldSystemJoinMemberFeeLog', meta: { permission: [], permission_tag: ['old_system_join_member_fee_log'], permission_type: ['search'] }},
          { name: '互助金', url: '/backstage/yf/oldSystemAmountLog', meta: { permission: [], permission_tag: ['old_system_amount_log'], permission_type: ['search'] }},
          { name: '業務', url: '/backstage/yf/oldSystemSalesLog', meta: { permission: [], permission_tag: ['old_system_sales_log'], permission_type: ['search'] }},
      ]
  }
];

/**
 * 權限設定資料
 */
export const permission_settings =  [
  {
    text: '契約管理',
    value: 'contract_management',
    children: [
      {
        text: '契約',
        value: 'contract',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false,

          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '契約促銷設定',
        value: 'contract_promotion_setting',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '通知書',
        value: 'notice',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      }
    ]
  },
  {
    text: '業務管理',
    value: 'business_management',
    children: [
      {
        text: '業務',
        value: 'business',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '業務組織樹',
        value: 'business_organization_tree',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '每期業務權益2.0總表',
        value: 'business_equity_V2',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      }
    ]
  },
  {
    text: '帳單管理',
    value: 'bill_management',
    children: [
      {
        text: '未繳帳單',
        value: 'unpaid_bills',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '列印當月全部未繳帳單',
        value: 'current_month_bill',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '繳費細項',
        value: 'pay_details',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '帳單設定',
        value: 'billing_settings',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      }
    ]
  },
  {
    text: '理賠',
    value: 'claims',
    children: [
      {
        text: '未處理互助金',
        value: 'unprocessed_mutual_aid_money',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '已理賠互助金',
        value: 'claimed_aid_fund',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '身故請領表',
        value: 'deceased_claim_form',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '匯出理賠',
        value: 'export_claim',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      }
    ]
  },
  {
    text: '報表',
    value: 'report',
    children: [
      {
        text: '查詢已繳費',
        value: 'paid_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '每月新增人數',
        value: 'monthly_new_user_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '每月身故理賠人數',
        value: 'monthly_deceased_user_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '身故會員理賠分布',
        value: 'death_member_claim',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '每月繳滿人數',
        value: 'monthly_full_payment_count',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '地區相關數據',
        value: 'regional_data_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '帳單相關數據',
        value: 'bill_data_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '每月件數',
        value: 'monthly_count_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '互助人年齡層分布',
        value: 'member_age_distribution_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '業務年齡層分布',
        value: 'sales_age_distribution_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '失效會員繳款次數',
        value: 'member_exclusion_paycount',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '匯出報表',
        value: 'export_report',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
    ]
  },
  {
    text: '設定',
    value: 'set',
    children: [
      {
        text: '環境設定',
        value: 'config',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '安全中心',
        value: 'security_center',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '前台數據設定',
        value: 'frontend_data_setup',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      },
      {
        text: '權限設定',
        value: 'permission_settings',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          },
          {
            text: '編輯',
            value: 'update',
            isCheck: false
          }
        ]
      }
    ]
  },
  {
    text: '操作日誌',
    value: 'log',
    children: [
      {
        text: '契約',
        value: 'contract_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '業務',
        value: 'business_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '帳單',
        value: 'bill_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      }
    ]
  },
  {
    text: '舊系統-操作日誌',
    value: 'old_system_log',
    children: [
      {
        text: '契約',
        value: 'old_system_contract_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '契約繳費通知地址',
        value: 'old_system_contract_pay_notice_address_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '入會費',
        value: 'old_system_join_member_fee_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '互助金',
        value: 'old_system_amount_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      },
      {
        text: '業務',
        value: 'old_system_sales_log',
        children: [
          {
            text: '查看',
            value: 'search',
            isCheck: false
          }
        ]
      }
    ]
  },
]




// WEBPACK FOOTER //
// ./src/models/HELPERS/options.js